/**
 * AdminGroup
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useApi2call } from 'containers/Api2/index.js';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import messages from '../messages.js';

function AdminGroup(props) {
  const { group, user, onChange } = props;
  const api2call = useApi2call();

  const confirmRemoveFromGroup = { ...messages.confirmRemoveFromGroup, values: group };
  async function handleDelete() {
    await api2call({
      method: 'DELETE',
      url: `sa/users/${user.typeName}/${user.id}/administrativeGroups/${group.id}`,
      version: 2,
      withPromise: true,
    });
    if (onChange) {
      onChange();
    }
  }
  return (
    <div className="d-flex align-items-start">
      <div className="flex-grow-1 d-sm-flex align-items-center">
        <AvatarWithText group align="center">
          {group.name}
        </AvatarWithText>
      </div>
      <div className="text-nowrap">
        {group.yearClass && (
          <span className="small text-muted">
            <FormattedMessage {...messages.gradeFull} values={group} />
          </span>
        )}
        {group.schoolsYear && (
          <span className="small text-muted">
            {` (${group.schoolYear})`}
          </span>
        )}
        <DeleteButton
          onClick={handleDelete}
          confirmText={confirmRemoveFromGroup}
          confirmLabel={messages.removeFrom}
          className="pe-0 py-0 ms-2"
        />
      </div>
    </div>
  );
}

AdminGroup.propTypes = {
  group: PropTypes.object,
  user: PropTypes.object,
  onChange: PropTypes.func,
  // linkPage: PropTypes.string,
};

export default AdminGroup;
